<template>
    <v-app style="position: relative">
        <v-main style="margin-top: 68px;">
            <slot></slot>
        </v-main>
      <v-bottom-navigation height="72"  color="primary" app>
        <v-btn height="72" class="pb-4" x-large link to="/drugs">
          <span>Dorilar</span>

          <v-icon>mdi-list-box-outline</v-icon>
        </v-btn>
        <v-btn height="72" class="pb-4" x-large link to="/samples">
          <span>Shablonlar</span>

          <v-icon>mdi-file-document-check-outline</v-icon>
        </v-btn>

        <v-btn height="72" class="pb-4" x-large link to="/patients">
          <span>Bemorlar</span>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-btn>

        <v-btn height="72" class="pb-4" x-large link @click="$router.push({name: 'profile'})">
          <span>Profile</span>
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-bottom-navigation>
<!--        <div class="overlay" :style="opened? 'top: 70px': 'top: 93%'">-->
<!--          <v-btn block color="primary" elevation="0" @click="opened = !opened" rounded>Qabullar tarixi <v-icon>mdi-chevron-{{ opened ? 'down': 'up' }}</v-icon> </v-btn>-->
<!--          <history-cards></history-cards>-->
<!--        </div>-->
    </v-app>

</template>

<script>

export default {
    name: "LayoutRecipe",
    components: {
    },
    data() {
        return {
          opened: false
        }
    }
}
</script>

<style scoped>
.menu-icon {
    position: fixed;
    top: 20px;
    z-index: 153;
    cursor: pointer;
    transition: 0.2s;
}

.menu-icon:hover {
    opacity: 0.8;
}

.menu-icon:active {
    opacity: 0.6;
}
.overlay{
  position: fixed;
  right: 0;
  bottom: 0;
  width: 320px;
  z-index: 100;
  border-left: 1px solid #e0e0e0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  top: 70px;
  overflow: hidden;
  transition: 300ms;
  animation-timing-function: ease-out;
  box-shadow: gray 0 0 10px 0;
}


</style>
